const MESSAGE = Object.freeze({
  INPUTEMAIL: '이메일을 입력해 주세요',
  EMAILERROR: '@가 포함되어야 합니다.',
  INPUTPASSWORD: '비밀번호를 입력해 주세요',
  PASSWORDERROR: '8자리 이상이어야 합니다.',
});

export default MESSAGE;
